import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=4eb5f2fe&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=js&"
export * from "./Cookies.vue?vue&type=script&lang=js&"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=4eb5f2fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5f2fe",
  null
  
)

export default component.exports